const e = {
  name: "Lock3",
  dimensions: { width: 22, height: 22 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 12C11.5523 12 12 12.4477 12 13V16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16V13C10 12.4477 10.4477 12 11 12Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C8.23858 0 6 2.23858 6 5V7H2C0.895431 7 0 7.89543 0 9V11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11V9C22 7.89543 21.1046 7 20 7H16V5C16 2.23858 13.7614 0 11 0ZM14 7V5C14 3.34315 12.6569 2 11 2C9.34315 2 8 3.34315 8 5V7H14ZM2 9V11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11V9H2Z" fill="currentColor"/>
    `
};
export {
  e as Lock3
};
